module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch4"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch4.jpg",
      "width": "14%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("The engines roared. Dr. D turned the wheel, and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cassandra")]), _vm._v(" edged sharply into the waves.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sheena and I took our places on a bench against the cabin wall. The boat rocked hard, and a strong spray washed over the railing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Soon, we were crashing over the sparkling waves. A red-orange sun floated on the horizon. I turned back and saw the tiny island of Careebo vanish, a speck of yellow on the blue water.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("About an hour later, Dr. D locked the wheel. Then he led the way down to the galley for some lunch.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Normally, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cassandra")]), _vm._v(" has a crew of three or four. But when Sheena and I visit in the summer, Dr. D likes to give them time off.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He pulled out the grilled bluefish left over from last night’s dinner and some sandwich rolls, and we sat around the small white table and ate fish sandwiches and drank papaya juice.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After lunch, Dr. D pulled off his glasses and cleaned them with his napkin. “I’ll tell you what we’re doing,” he said. “But you probably won’t believe me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He chuckled. “I’m not sure I believe it myself. But we’re going to try to track down a sunken pirate ship.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("My mouth dropped open. “You mean like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("real")]), _vm._v(" pirates?” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dr. D nodded and slid his glasses back on. “People have been searching for this ship for over two hundred years,” he said. “My workers back on the mainland think they have located it using acoustic imaging and laser mapping. They just e-mailed me all the info.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dr. D’s eyes flashed. “Here’s the amazing thing,” he said. “If the sonar image is correct, we’re actually not too far from where the ship went down.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sheena and I nodded and waited for him to tell us more.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The ship is called the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Scarlet Skull")]), _vm._v(",” he said. “Perfect name for a pirate ship, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He took a long sip of papaya juice. “According to legend, the ship sank in the late 1780s,” he said. “And it took millions of dollars of jewels and gold treasure down with it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And we’re going to find the treasure and be "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("billionaires")]), _vm._v("!” I cried. I jumped up and pumped my fists in the air.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sheena grabbed me and pulled me back down. “Billy, were you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("born")]), _vm._v(" immature?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If we find the treasure, it will all go to the Careebo Dolphin Rescue Fund,” Dr. D said. “I’d be thrilled to find it. But I’m a scientist — not a treasure hunter.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This is totally cool!” I said. I was so excited, I could barely sit still.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How did the pirate ship go down?” Sheena asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dr. D scratched his head. “This is where the story gets weird,” he said. “And this is what I want to investigate. The reports at the time said there were "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("two")]), _vm._v(" pirate ships. They were sailing in view of each other. It was a calm, clear day. The ocean waves were flat and gentle. And suddenly, a swirling black cloud swept over the water. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Scarlet Skull")]), _vm._v(" sailed into the cloud — and disappeared.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Huh? It just disappeared?” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dr. D nodded. “I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("told")]), _vm._v(" you it was weird. The black cloud passed, and the pirate ship had vanished. The pirates on the other ship stood staring, waiting for it to reappear. But … it was never seen again.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sheena and I stared at him. Neither of us spoke.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dr. D opened a file of papers he had brought to lunch and scanned them quickly. “The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Scarlet Skull")]), _vm._v(" belonged to a notorious captain named Long Ben One-Leg,” he said. “Long Ben was very bad news.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I felt a shiver at the back of my neck. “How bad?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, some people believe that he was so evil, the sea just swallowed him up. Swallowed him and his entire ship to protect the world from his evil.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dr. D continued to skim the papers. “Here’s a story that will give you a good idea of what Captain Ben was like. It seems he kept a big tub of hungry rats on the ship. When one of his men did something to make him angry, he tossed the guy into the tub. Then he sat back and watched the rats make lunch of him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sheena grabbed her throat and groaned. “Ohhh, that’s way sick!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sometimes when he was bored,” Dr. D continued, “he threw someone in the rat tub just for entertainment.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They didn’t have TV in those days, right?” I joked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But when I pictured the hungry rats gnawing on some poor guy, I felt a little sick.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So all the pirates drowned when the ship went down?” Sheena asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dr. D nodded. “The pirates drowned. The rats drowned. And the treasure sank with them.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He set the papers on the table and squeezed Sheena’s hand. “And there’s one more part to the story. A very creepy part.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stopped as if he didn’t want to tell us.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We waited, our eyes locked on his. “Tell us,” I said. “Please. Tell us!”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a1dcb59","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545840330_ch004.vue
// module id = 81
// module chunks = 0